import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Feb 05 2019
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { inject, observer, Observer } from 'mobx-react';
import * as React from 'react';
import { LoadingState } from '../../../shared/api/LoadingState';
import { StoreName } from '../../../shared/stores/StoreName';
import Loader from '../../info/Loader';

var DictionaryProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DictionaryProvider, _React$Component);

  function DictionaryProvider() {
    var _this;

    _classCallCheck(this, DictionaryProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DictionaryProvider).apply(this, arguments));

    _this.render = function () {
      return React.createElement(Observer, null, function () {
        return _this.props.store.loadingState === LoadingState.Pending ? React.createElement(Loader, null) : _this.props.children;
      });
    };

    return _this;
  }

  _createClass(DictionaryProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.store.initLanguage();
    }
  }]);

  return DictionaryProvider;
}(React.Component);

DictionaryProvider = __decorate([inject(function (allStores) {
  return {
    store: allStores[StoreName.Dictionary]
  };
}), observer], DictionaryProvider);
export default DictionaryProvider;